import { gsap } from 'gsap/gsap-core';

import { CloneModal } from '../cloneme-classes/CloneModal';
import { Elements } from '../cloneme-classes/Elements';
import { FetchData } from '../cloneme-classes/FetchData';

export class CloneMeConsumer {
  elements: Elements = new Elements();

  constructor() {
    console.log('consumer open');
  }
  public async init(): Promise<void> {
    if (document.querySelector('[cc-type="dev"]')) {
      const divToClone = this.elements.get('componentWrapper');

      FetchData.fetchGetInfluencers()
        .then((data) => {
          // Extract the desired data
          data.data.forEach(
            (influencer: { attributes: { name: string; byline: string }; id: number }) => {
              // Now you have the data in variables. You can use these in your class or pass them to other methods.
              //this.startChat(data[0].id);
              const { name, byline } = influencer.attributes;
              const { id } = influencer;

              // Your code here
              console.log(`Name: ${name}\nByline: ${byline}\nID: ${influencer.id}\n`);

              // Select the element you want to duplicate

              if (divToClone) {
                // Clone the element
                const clonedDiv = divToClone.cloneNode(true) as HTMLElement;
                //!!!! HARD CODED MEMBER ID
                clonedDiv.setAttribute('data-influencer-id', id.toString()); // Convert id to string before setting it as an attribute value
                clonedDiv.setAttribute('data-user-id', '3'); // Convert id to string before setting it as an attribute value
                const headerElement = clonedDiv.querySelector('[cc-element="header"]');
                const bylineElement = clonedDiv.querySelector('[cc-element="byline"]');
                if (headerElement) {
                  headerElement.textContent = name;
                }
                if (bylineElement) {
                  bylineElement.textContent = byline;
                }
                // Append the cloned element to the desired location (in this case, just after the original div)
                divToClone.after(clonedDiv);
              }
            }
          );
          divToClone?.remove();
          const modals = new CloneModal(data);
          modals.init();
        })
        .catch((error) => {
          console.error('Error while creating chat:', error);
        });
    } else {
      const modals = new CloneModal();
      modals.init();
    }
  }
}
